<template>
  <div id="work">
    <div id="work-main">

      <div id="title-section">
        <div id="work-sim"></div>
        <div id="title">
          <h1>Work</h1>
          <p v-if="activeTag === 'all'">Showing <b>all {{activeProjects.length}}</b> projects</p>
          <p v-else>Showing <b>{{activeProjects.length}} {{activeTag | parseTag}}</b> projects</p>
        </div>
      </div>

        <div id="filter-section" class="grid-item">
          <div id="filters">
            <h3>I want to see</h3>
            <work-filter
            v-for="(tag, i) in tags"
            :key="tag.id"
            :tag="tag"
            @click.native="activateFilter(i)"/>
            <h3>projects.</h3>
          </div>
        </div>

      <project-card
        v-for="project in activeProjects"
        :key="project.id"
        :title="project.title"
        :year="project.year"
        :client="project.client"
        :slug="project.slug"
        :color="project.color"
        :contrastColor="project.contrast"
        :brief="project.brief"
        :tags="project.tags"
        :featured="project.featured"
        :class="{featured: project.featured}"
        class="grid-item"/>

    </div>

    <app-footer></app-footer>

  <vue-headful title="DA | Work" />
  </div>
</template>

<script>
import AppFooter from '../components/Footer.vue'
import ProjectCard from '../components/work/ProjectCard.vue'
import WorkFilter from '../components/work/Filter.vue'
import projects from '../assets/projects.json'
import { CanvasSpace, Create, World, Particle, Num } from 'pts'
import anime from 'animejs'

export default {
  components: { ProjectCard, AppFooter, WorkFilter },
  data () {
    return {
      projects: projects,
      allItems: [],
      tags: [],
      filterElements: [],
      activeTag: 'all',
      activeProjects: [],
      particleAmt: 9,
      particleCursorSize: 20,
      particleBaseSize: 10,
      particleSizeModifier: 15,
      particleHitAmt: 25,
      particleMoveActive: true,
      particleHitTimer: 1500,
      particles: []
    }
  },
  methods: {
    activateFilter (i) {
      let count = -1

      this.filterElements.forEach(el => {
        count++

        if (count === i) {
          el.classList.add('active')
          this.activeTag = this.tags[i]
        } else {
          el.classList.remove('active')
        }
      })

      this.filterProjects()
    },
    filterProjects () {
      this.activeProjects = []

      Object.entries(projects).forEach(([key, project]) => {
        if (this.activeTag === 'all') {
          this.activeProjects.push(project)
        } else if (project.tags.includes(this.activeTag)) {
          this.activeProjects.push(project)
        }
      })
    },
    animateCards () {
      anime.remove('.project-card')
      anime.remove('.project-card .card-bg')
      anime.remove('.project-card svg')
      anime.remove('.project-card svg circle')
      anime.remove('.project-card svg path')
      anime.remove('.project-card .card-tags .card-tag')

      setTimeout(() => {
        anime({
          targets: '.project-card',
          translateY: ['10%', 0],
          opacity: [0, 1],
          easing: 'easeOutQuart',
          delay: anime.stagger(50)
        })
      }, 1)
    },
    moveParticles () {
      this.particles.forEach(particle => {
        particle.hit(Num.randomRange(-this.particleHitAmt / 5, this.particleHitAmt / 5), Num.randomRange(-this.particleHitAmt / 5, this.particleHitAmt / 5))
      })
    }
  },
  beforeMount () {
    delete projects.template
    this.$store.state.activeProject = projects.motion

    this.tags = new Set()
    this.tags.add('all')

    Object.entries(projects).forEach(([key, project]) => {
      project.tags.forEach(tag => {
        this.tags.add(tag)
      })
    })

    this.tags = [...this.tags]
  },

  mounted () {
    this.filterElements = document.querySelectorAll('.filter')

    let matchQueryToTags = (el) => { return el === this.$route.query.tag }

    if (this.$route.query.tag === undefined) {
      this.activateFilter(0)
    } else {
      this.tags.findIndex(matchQueryToTags) >= 0 ? this.activateFilter(this.tags.findIndex(matchQueryToTags)) : this.activateFilter(0)
    }

    this.animateCards()

    let i = 0
    setTimeout(() => {
      let projectCards = document.querySelectorAll('.project-card')

      projectCards.forEach(el => {
        i++
        setTimeout(() => {
          el.style.opacity = 1
        }, i * 50)
      })
    }, 150)

    var space = new CanvasSpace('#work-sim').setup({ bgcolor: 'transparent', resize: true, retina: true })
    var form = space.getForm()

    var world

    space.add({

      start: (bound, space) => {
        // Create world and 100 random points
        world = new World(space.innerBound, 1, 0)
        let pts = Create.distributeRandom(space.innerBound, this.particleAmt)

        // Create particles and hit them with a random impulse
        for (let i = 0, len = pts.length; i < len; i++) {
          let p = new Particle(pts[i]).size((i === 0) ? this.particleCursorSize : this.particleBaseSize + Math.random() * space.size.x / this.particleSizeModifier)
          p.hit(Num.randomRange(-this.particleHitAmt, this.particleHitAmt), Num.randomRange(-this.particleHitAmt / 2, this.particleHitAmt / 2))
          world.add(p)
          this.particles.push(p)
        }

        setInterval(() => {
          if (this.particleMoveActive) {
            this.moveParticles()
          }
        }, this.particleHitTimer)
      },

      animate: (time, ftime) => {
        world.drawParticles((p, i) => {
          let color = ['#1F2933', '#323F4B', '#3E4C59'][i % 3]
          form.fillOnly(color).point(p, p.radius, 'circle')
        })

        world.update(ftime)
      },

      resize: (bound, evt) => {
        if (world) world.bound = space.innerBound
      }
    })

    space.bindMouse().bindTouch()
    space.play()

    // document.querySelector('#work-sim canvas').style.zIndex = '0'

    setTimeout(() => {
      document.querySelector('#title-section').style.display = 'block'
    }, 500)
  },
  updated () {
    this.animateCards()
  }
}

</script>

<style lang="scss" scoped>

  #work-main {
    @extend %container;
    box-sizing: border-box;

    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(330px, 1fr));
    //grid-auto-rows: min-content max-content auto;
    grid-auto-rows: 1fr;
    grid-gap: $grid-gap;
    grid-auto-flow: dense;

    @include phone-only {
       grid-template-columns: 100%;
    }
  }

  #title-section {
    background-color: transparent;
    position: relative;
    // border: 1px solid $gray8;
    box-sizing: border-box;

    #work-sim {
      height: 100%;
      max-height: 280px;
      z-index: 500;
    }

    #title {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      user-select: none;
      pointer-events: none;

      @include phone-only {
        align-items: flex-start;
        justify-content: flex-end;
      }

      h1 {
        font-family: $title-font;
        color: $gray8;
        font-size: 5rem;
        margin: 0;
      }

      p {
        color: $gray6;

        b {
          color: $gray8;
        }
      }
    }

  }

  #filter-section {
    grid-row: span 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $gray8;

    #filters {
      // display: block;
      align-items: center;
      //padding: 2rem 4rem;
      padding: 8%;
      box-sizing: border-box;

      display: flex;
      flex-flow: wrap;

      h3 {
        color: $gray2;
        display: inline-block;
        font-size: 2rem;
        font-family: $body-font;
        margin-right: 1rem;

        @include tablet-below {
          font-size: 1.75rem;
        }

        &:first-of-type, &:nth-last-child(2) {
          margin-right: .5rem;
        }

      }

    }
  }

</style>
